import { allowedPaymentOptions } from "httpClient/requests/checkoutPage/payment";
import { setAllowedPaymentOptions } from "../actions";

export default function getAllowedPaymentOptions() {
   return async (dispatch, getState) => {
     try {
      const websiteId = getState().settings.value.websiteId;
       const response = await allowedPaymentOptions(websiteId);
       const { data } = response;
       
       dispatch(setAllowedPaymentOptions(data));
     } catch (error) {
       console.error(error);
     }
   };
 }
 